import React, { useEffect, useState } from 'react'
import DoggosLoading from '../DoggosLoading'
import * as templateStyle from '../Template/style.module.scss'
import { isCrmPath } from '../../utils/crmPaths'

/**
 * Public routes (homepage, search, tracker, …) must not import CrmAppShell —
 * that module graph pulls stream-chat-react into commons.js (~11MB in develop).
 * Load the shell only when navigating to a CRM path.
 */
let shellPromise = null
let cachedShell = null

function loadCrmAppShell() {
  if (!shellPromise) {
    shellPromise = import('./index').then((mod) => {
      cachedShell = mod.default
      return mod.default
    })
  }
  return shellPromise
}

function CrmShellBoot({ dashboard }) {
  return <div className={dashboard ? templateStyle.dashboardShell : undefined}><DoggosLoading aria-label="Loading" layout={dashboard ? "dashboard" : "page"} /></div>
}

export default function LazyCrmAppShell({ location, children }) {
  const crmRoute = isCrmPath(location?.pathname)
  const [Shell, setShell] = useState(() => cachedShell)

  useEffect(() => {
    if (!crmRoute) return undefined
    if (cachedShell) {
      setShell(() => cachedShell)
      return undefined
    }
    let cancelled = false
    void loadCrmAppShell()
      .then((Component) => {
        if (!cancelled) setShell(() => Component)
      })
      .catch((err) => {
        console.error('[LazyCrmAppShell] failed to load CrmAppShell', err)
      })
    return () => {
      cancelled = true
    }
  }, [crmRoute])

  if (!crmRoute) return children
  if (!Shell) return <CrmShellBoot dashboard={/^\/dashboard(?:\/|$)/.test(location?.pathname || "")} />
  return <Shell location={location}>{children}</Shell>
}
